<template>
    <div class="mainC container" style="background: white;">
     <ul class="" style="list-style-type: none; font-weight: 550; padding-left: 0px;">
      <!-- <li style="background: #d6d6d6; font-size: 15px; color: green; font-weight: 550; line-height: 2" class="row">
          <span class="col-2" style="text-align: center;">Position</span>
          <span class="col">User</span>
          <span class="col">Points</span>
      </li> -->
      <li class="first row" style="font-size: 15px; line-height: 2;">
          <span class="col-2" style="text-align: center;"><img src="@/assets/crown1.png" style="width: 22px;" alt=""></span>
          <span class="col">55123**67</span>
          <span class="col">10965</span>
      </li>
      <li class="row" style="background: #f3f1ed; font-size: 15px; line-height: 2;">
          <span class="col-2" style="text-align: center;"><img src="@/assets/crown2.png" style="width: 22px;" alt=""></span>
          <span class="col">54123**71</span>
          <span class="col">8566</span>
      </li>
      <li class="row" style="background: white; font-size: 15px; line-height: 2;">
          <span class="col-2" style="text-align: center;"><img src="@/assets/crown3.png" style="width: 22px;" alt=""></span>
          <span class="col">59188**67</span>
          <span class="col">7955</span>
      </li>
      <li style="background: #f3f1ed; font-size: 15px; line-height: 2;" class="row">
          <span class="col-2" style="text-align: center;">4</span>
          <span class="col">58950**74</span>
          <span class="col">7966</span>
      </li>
      <li style="background: white; font-size: 15px; line-height: 2;" class="row">
          <span class="col-2" style="text-align: center;">5</span>
          <span class="col">86695**66</span>
          <span class="col">5600</span>
      </li>
      <li style="background: #f3f1ed; font-size: 15px; line-height: 2;" class="row">
          <span class="col-2" style="text-align: center;">6</span>
          <span class="col">87756**78</span>
          <span class="col">4500</span>
      </li>
      <li style="background: white; font-size: 15px; line-height: 2;" class="row">
          <span class="col-2" style="text-align: center;">7</span>
          <span class="col">87756**69</span>
          <span class="col">3580</span>
      </li>
      <li style="background: #f3f1ed; font-size: 15px; line-height: 2;" class="row">
          <span class="col-2" style="text-align: center;">8</span>
          <span class="col">87756**80</span>
          <span class="col">2545</span>
      </li>
     </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Leaderboard',
   data(){
      return{
        leaderList: [],
        cookiesObject: '',
      }
  },
  async beforeMount(){
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    this.getList();
  },

  methods:{
     getList(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq +"/game/leaderboard?token=" + this.cookiesObject.token, requestOptions)
        .then(response => response.json())
        .then(result => {
            this.leaderList = result.users;
        })
        .catch(error => console.log('error', error));
    }
  },
  components: {
   
  },
  computed:{
    ...mapGetters(['httpReq']),
  },
}
</script>

<style scoped>
.first{
background-image: linear-gradient(to right, #dacb68, #9b7b23);
}
.second{
background-image: linear-gradient(to right, #ffffff, #dad6ca);
}
.bbg{
  background: #f0ecec !important;
}

.mainC{
    margin-top: 0px !important;
}

#router-link{
    color: black;
    text-decoration: none;
}

.container{
    margin-top: 12px;
}

li{
   line-height: 18px;
   border-radius: 0px !important;
   font-size: 12px;
}
.LeagueName{
    margin-bottom: 10px;
}

.header{
    background: #d6d6d6;
    color: black;
}

.bodyElement{
    padding: 0;
    height: 28px;
}

.game{
    text-align: center;
}
.game :hover{
    color: #309a3d;
}

@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}

</style>
